import {
  LOT_TYPES,
  SESSION_TYPES,
  PARTICIPANT_TYPES,
  LOT_STATUSES,
  USER_TYPES,
  SUBSCRIPTION_TYPES,
  DOCUMENT_STATUSES,
  REQUEST_STATUSES,
  ORG_REQUEST_STATUSES,
  LOT_REQUEST_STATUSES,
  ORGANIZATION_TABS,
  USER_TABS,
  LOT_TABS,
  DOCUMENT_TYPES,
  TRADE_DIRECTION_TYPES,
  LOT_REQUEST_TYPES,
  TRADE_RESULT_TYPES,
  SESSION_STATUSES,
  PREMIUM_TYPES,
  STATIC_FILE_TYPES
} from './business'

export const PARTICIPANT_TYPE_ADMIN_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.PARTICIPANT]: 'Участник (Покупатель)',
  [PARTICIPANT_TYPES.ORGANIZER]: 'Организатор (Продавец)',
  [PARTICIPANT_TYPES.SUPER_ORGANIZER]: 'Администратор'
})

export const PREMIUM_TYPE_ENUM = Object.freeze({
  [PREMIUM_TYPES.DIFFERENTIAL]: 'Дифференциал к базису ценообразования',
  [PREMIUM_TYPES.FIX]: 'Фиксированная цена'
})

export const PARTICIPANT_TYPE_EDIT_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.PARTICIPANT]: 'Участник (Покупатель)'
})

export const PARTICIPANT_TYPE_ROUTE_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.PARTICIPANT]: 'Участник (Покупатель)',
  [PARTICIPANT_TYPES.ORGANIZER]: 'Организатор (Продавец)'
})

export const PARTICIPANT_TYPE_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.PARTICIPANT]: 'Участник (Покупатель)',
  [PARTICIPANT_TYPES.ORGANIZER]: 'Организатор (Продавец)',
  [PARTICIPANT_TYPES.SUPER_ORGANIZER]: 'Администратор'
})

export const PARTICIPANT_TYPE_TIP_ENUM = Object.freeze({
  [PARTICIPANT_TYPES.PARTICIPANT]: 'Юридическое лицо, действующее на ЭП от своего имени и за свой счет, имеющий право участвовать в Торгах по Лоту в соответствии с Регламентом',
  [PARTICIPANT_TYPES.ORGANIZER]: 'Юридическое лицо, действующее на ЭП от своего имени и за свой счет, имеющий право организовывать Торги по Лоту в соответствии с Регламентом',
  [PARTICIPANT_TYPES.SUPER_ORGANIZER]: 'Администратор'
})

export const SUBSCRIPTIONS_TYPE_ENUM = Object.freeze({
  [SUBSCRIPTION_TYPES.FULL]: 'Все подписки включены',
  [SUBSCRIPTION_TYPES.PARTIAL]: 'Есть подписки',
  [SUBSCRIPTION_TYPES.NONE]: 'Подписки отключены'
})

// export const ORGANIZATION_TYPE_ENUM = Object.freeze({
//   [ORGANIZATION_TYPES.LEGAL]: 'Юридическое лицо',
//   [ORGANIZATION_TYPES.INDIVIDUAL]: 'Индивидуальный предприниматель'
// })

export const STATUS_ENUM = Object.freeze({
  [DOCUMENT_STATUSES.INPROCESS]: 'В обработке',
  [DOCUMENT_STATUSES.APPROVED]: 'Одобрен',
  [DOCUMENT_STATUSES.DISABLED]: 'Отказано'
})

export const REQUEST_STATUS_ENUM = Object.freeze({
  [REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  [REQUEST_STATUSES.INPROCESS]: 'В обработке',
  [REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const ORG_REQUEST_STATUS_ENUM = Object.freeze({
  [ORG_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  [ORG_REQUEST_STATUSES.INPROCESS]: 'В обработке у Организатора',
  [ORG_REQUEST_STATUSES.REJECTED]: 'Отклонен Организатором',
  [ORG_REQUEST_STATUSES.APPROVED]: 'Одобрен Организатором'
})

export const ORG_REQUEST_STATUS_SHORT_ENUM = Object.freeze({
  [ORG_REQUEST_STATUSES.INPROCESS]: 'В обработке у Организатора',
  [ORG_REQUEST_STATUSES.REJECTED]: 'Отклонен Организатором',
  [ORG_REQUEST_STATUSES.APPROVED]: 'Одобрен Организатором'
})

export const LOT_REQUEST_STATUS_ENUM = Object.freeze({
  [LOT_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  // [LOT_REQUEST_STATUSES.INPROCESS]: 'В обработке',
  // [LOT_REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [LOT_REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const LOT_REQUEST_STATUS_SHORT_ENUM = Object.freeze({
  [LOT_REQUEST_STATUSES.CREATED]: 'Создан, но не отправлен',
  // [LOT_REQUEST_STATUSES.INPROCESS]: 'В обработке',
  // [LOT_REQUEST_STATUSES.REJECTED]: 'Отклонен',
  [LOT_REQUEST_STATUSES.APPROVED]: 'Одобрен'
})

export const LOT_TYPE_ENUM = Object.freeze({
  [LOT_TYPES.PUBLIC_REQUEST_OFFERS]: 'Приглашение делать оферты [открытая форма подачи оферт]',
  [LOT_TYPES.PRIVATE_REQUEST_OFFERS]: 'Приглашение делать оферты [закрытая форма подачи оферт]',
  [LOT_TYPES.TWO_STAGED_OFFERS]: 'Двухэтапный запрос оферт'
})

export const SESSION_TYPE_ENUM = Object.freeze({
  [SESSION_TYPES.PUBLIC_OFFERS]: 'Открытая по форме подачи оферт',
  [SESSION_TYPES.PRIVATE_OFFERS]: 'Закрытая по форме подачи оферт',
  [SESSION_TYPES.PRIVATE_TWO_STAGED_OFFERS]: 'Закрытая (1-ый этап)',
  [SESSION_TYPES.PUBLIC_TWO_STAGED_OFFERS]: 'Открытая (2-ой этап)'
})

export const STATIC_FILE_TYPE_ENUM = Object.freeze({
  [STATIC_FILE_TYPES.PICTURE]: 'Картинки',
  [STATIC_FILE_TYPES.DOC]: 'Документы'
})

export const ORGANIZATION_TABS_ENUM = Object.freeze({
  [ORGANIZATION_TABS.GENERAL_INFO]: 'Общая информация',
  // [ORGANIZATION_TABS.USERS]: 'Уполномоченные представители',
  [ORGANIZATION_TABS.DOCUMENTS]: 'Документы'
})

export const ORGANIZATION_TABS_ADMIN_ENUM = Object.freeze({
  [ORGANIZATION_TABS.GENERAL_INFO]: 'Общая информация',
  [ORGANIZATION_TABS.USERS]: 'Уполномоченные представители',
  [ORGANIZATION_TABS.DOCUMENTS]: 'Документы'
})

export const USER_TABS_ENUM = Object.freeze({
  [USER_TABS.USER_INFO]: 'Общая информация',
  [USER_TABS.AUTHORIZATION_DOCUMENTS]: 'Документы',
  [USER_TABS.SUBSCRIPTIONS]: 'Подписки'
})

export const LOT_TABS_ENUM = Object.freeze({
  [LOT_TABS.GENERAL_INFO]: 'Общая информация',
  [LOT_TABS.LOT_DOCUMENTS]: 'Документы и разъяснения',
  [LOT_TABS.TRADE_PROCESS_DOCUMENTATION]: 'Итоги торгов',
  [LOT_TABS.TRADE_PROCESS]: 'Процесс торгов',
  [LOT_TABS.ORDERS]: 'Список предложений',
  [LOT_TABS.TRADE_RESULTS]: 'Результаты торгов',
  [LOT_TABS.LOT_REQUESTS]: 'Запросы по торговой процедуре'
})

export const TRADE_PROCESS_DOCUMENTATION_ENUM = Object.freeze({
  [DOCUMENT_TYPES.NOTES]: 'Примечания',
  [DOCUMENT_TYPES.REGISTRY]: 'Рейтинг оферт',
  [DOCUMENT_TYPES.OFFERER_NOTIFICATION]: 'Уведомление оферентам'
})

export const DOCUMENT_TYPE_ENUM = Object.freeze({
  ...TRADE_PROCESS_DOCUMENTATION_ENUM,
  [DOCUMENT_TYPES.CLARIFICATION]: 'Разъяснение по торговой процедуре',
  [DOCUMENT_TYPES.OFFER_ADDITIONAL_INFO]: 'Дополнительные условия к оферте',
  [DOCUMENT_TYPES.NOTES]: 'Примечания',
  [DOCUMENT_TYPES.DOCUMENTATION]: 'Документация о торгах',
  [DOCUMENT_TYPES.CONTRACT]: 'Типовой Контракт',
  [DOCUMENT_TYPES.NOTICE]: 'Извещение о торгах',
  [DOCUMENT_TYPES.STATEMENT]: 'Заявление на отзыв торговой процедуры',
  [DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT]: 'Документ, подтверждающий полномочия представителя',
  [DOCUMENT_TYPES.ORGANIZATION_DOCUMENT]: 'Регистрационный документ Пользователя ЭПЭ'
})

export const TRADE_DIRECTION_TYPE_ENUM = Object.freeze({
  [TRADE_DIRECTION_TYPES.RAISING]: 'На повышение цены',
  [TRADE_DIRECTION_TYPES.LOWERING]: 'На понижение цены'
})

export const LOT_REQUEST_TYPE_ENUM = Object.freeze({
  [LOT_REQUEST_TYPES.REGISTRATION]: 'Регистрация торговой процедуры',
  [LOT_REQUEST_TYPES.RECALL]: 'Отзыв торговой процедуры',
  [LOT_REQUEST_TYPES.CHANGE_DOCUMENTS]: 'Изменения в документации торговой процедуры',
  [LOT_REQUEST_TYPES.CONTRACT_CONDITION_FAIL]: 'Подача уведомления о неисполнении договора'
})

export const LOT_STATUS_TYPE_ENUM = Object.freeze({
  [LOT_STATUSES.DRAFT]: 'Черновик',
  [LOT_STATUSES.REGISTERED]: 'Объявлена',
  [LOT_STATUSES.FINISHED]: 'Завершена',
  [LOT_STATUSES.RECALLED]: 'Отозвана'
})

export const LOT_STATUS_TYPE_SHORT_ENUM = Object.freeze({
  [LOT_STATUSES.REGISTERED]: 'Объявлена',
  [LOT_STATUSES.FINISHED]: 'Завершена',
  [LOT_STATUSES.RECALLED]: 'Отозвана'
})

export const USER_LIST_TABS_ENUM = Object.freeze({
  [USER_TYPES.REGISTERED]: 'Зарегистрированные',
  [USER_TYPES.UNREGISTERED]: 'Незарегистрированные'
})

export const TRADE_RESULT_TYPE_EDIT_ENUM = Object.freeze({
  [TRADE_RESULT_TYPES.UNSET]: 'Итог еще не определен.',
  [TRADE_RESULT_TYPES.FAILED]: 'Торги не состоялись',
  [TRADE_RESULT_TYPES.WINNER_SELECTED]: 'Победитель определен.'
})

export const TRADE_RESULT_TYPE_ENUM = Object.freeze({
  [TRADE_RESULT_TYPES.UNSET]: 'Итог еще не определен.',
  [TRADE_RESULT_TYPES.FAILED]: 'Торги не состоялись',
  [TRADE_RESULT_TYPES.WINNER_SELECTED]: 'Победитель определен.'
  // [TRADE_RESULT_TYPES.CONTRACT_FULFILLED]: 'Контракт исполнен.'
})

export const SESSION_STATUS_ENUM = Object.freeze({
  [SESSION_STATUSES.UNLOCKED]: 'Торги разрешены',
  [SESSION_STATUSES.LOCKED_BY_PARTICIPANT_COUNT]: 'Сессия завершена по причине участия в первой сессии менее двух участников.',
  [SESSION_STATUSES.LOCKED_BY_LIMIT_PREMIUM]: 'Сессия завершена по причине достижения предела возможной цены.'
})

export const SET_UNSET_ENUM = Object.freeze({
  true: 'Да',
  false: 'Нет'
})
export const LOT_TEMPLATE_TABS_ENUM = Object.freeze({
  [LOT_TABS.GENERAL_INFO]: 'Общая информация'
})
